import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from "@angular/core";

@Component({
  selector: "primary-button",
  templateUrl: "./primary-button.component.html",
  styleUrls: ["./primary-button.component.scss"],
})
export class PrimaryButtonComponent implements OnInit {
  @Input() loading = false;
  @Input() disabled = false;
  @Input() small = false;
  @Input() id: string;
  @Input() danger = false;
  @Output() onClick = new EventEmitter<any>();
  @ViewChild("iconSlot") iconSlot;
  hasIcon: boolean;

  constructor(private ref: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.hasIcon =
      this.iconSlot.nativeElement &&
      this.iconSlot.nativeElement.children?.length > 0;
    this.ref.detectChanges();
  }

  handleClick() {
    this.onClick.emit();
  }
}
